function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { Box } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import { media, themeGet } from "sprout-ui-theme";
import { useHistory, useLocation } from "react-router-dom";
import PostPageComment from "../PostPageComment";
import PostPageCommentEditor from "../PostPageCommentEditor";
import { usePostPageEditor } from "../PostPageEditorContext";
import PostPageDividerText from "../PostPageDividerText";
const borderStyles = css`
  > div + div {
    border-top: 1px solid ${themeGet("colors.black.12")};
  }
`;
const PostPageCommentsSpacer = styled(Box)`
  ${media.down("medium")} {
    ${borderStyles}
  }

  ${media.target("touch")} {
    ${borderStyles}
  }

  ${media.up("medium", "pointer")} {
    > :not(style) + :not(style) {
      margin-top: 16px;
    }
  }
`;
const PostPageComments = (props)=>{
    const { item , comments , commentCount  } = props;
    const { id  } = item;
    const { state  } = usePostPageEditor();
    const openReplyCommentEditor = state.editor === "REPLY_COMMENT" && state.editorPosition === id;
    // Logic to remove focussed comment
    const location = useLocation();
    const history = useHistory();
    useEffect(()=>{
        if (!location.hash) return undefined;
        const handler = ()=>{
            history.replace(_objectSpread({}, location, {
                hash: undefined
            }));
        };
        document.addEventListener("click", handler);
        return ()=>{
            document.removeEventListener("click", handler);
        };
    }, [
        history,
        location
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            commentCount > 0 && /*#__PURE__*/ _jsx(PostPageDividerText, {
                text: `${commentCount} comment${commentCount > 1 ? "s" : ""}`
            }),
            comments.length > 0 && /*#__PURE__*/ _jsx(PostPageCommentsSpacer, {
                children: comments.map((comment)=>{
                    return /*#__PURE__*/ _jsx(PostPageComment, {
                        parentItemId: item.id,
                        parentItemNodeId: item.nodeId,
                        comment: comment
                    }, comment.nodeId);
                })
            }),
            /*#__PURE__*/ _jsx(PostPageCommentEditor, {
                itemId: id,
                desktopMt: 7,
                parentItem: item,
                cacheKey: `#item-${item.id}`,
                open: openReplyCommentEditor ? state.variant : undefined
            })
        ]
    });
};
export default PostPageComments;
